import Vue from 'vue';

// 获取区域列表
function getLocationList(areaCode, level) {
  return Vue.axios.get('/api/v1.0/chanquan/area/selectAreaList/' + areaCode + '/' + level );
}

export default {
  getLocationList
};
